import { gql } from '@apollo/client';

// add Article categories
export const ADD_COMMUNITY_GROUP = gql`
  mutation Admin_community_group_add($createDTO: GroupAdminCreateDTO!) {
    admin_community_group_add(createDTO: $createDTO) {
      id
      active
      deleted
    }
  }
`;

// update Article categories
export const UPDATE_COMMUNITY_GROUP = gql`
  mutation Admin_community_group_update($groupId: String!, $createDTO: GroupAdminCreateDTO!) {
    admin_community_group_update(groupId: $groupId, createDTO: $createDTO) {
      id
      active
      deleted
    }
  }
`;

export const ADD_COMMUNITY_POST = gql`
  mutation Admin_community_post_add($createDTO: PostAdminCreateDTO!) {
    admin_community_post_add(createDTO: $createDTO) {
      id
    }
  }
`;

export const UPDATE_COMMUNITY_POST = gql`
  mutation Admin_community_post_update($postId: String!, $createDTO: PostAdminCreateDTO!) {
    admin_community_post_update(postId: $postId, createDTO: $createDTO) {
      id
    }
  }
`;

export const DELETE_COMMUNITY_POST = gql`
  mutation Admin_community_post_remove($postId: String!) {
    admin_community_post_remove(postId: $postId)
  }
`;

// Add Post Comment
export const ADD_POST_COMMENT = gql`
  mutation Admin_community_post_comment_add($createDTO: PostAdminCommentCreateDTO!) {
    admin_community_post_comment_add(createDTO: $createDTO) {
      id
    }
  }
`;
// Update Post Comment
export const UPDATE_POST_COMMENT = gql`
  mutation Admin_community_post_comment_update($commentId: String!, $createDTO: PostAdminCommentCreateDTO!) {
    admin_community_post_comment_update(commentId: $commentId, createDTO: $createDTO) {
      id
    }
  }
`;

// Delete Post Comment
export const DELETE_POST_COMMENT = gql`
  mutation Admin_community_post_comment_remove($commentId: String!, $removeChildren: Boolean!) {
    admin_community_post_comment_remove(commentId: $commentId, removeChildren: $removeChildren)
  }
`;

// Update Member from group
export const UPDATE_MEMBER_FROM_GROUP = gql`
  mutation Admin_community_member_update($memberId: String!, $createDTO: GroupMemberCreateDTO!) {
    admin_community_member_update(memberId: $memberId, createDTO: $createDTO) {
      id
    }
  }
`;

// Remove Member from group
export const REMOVE_MEMBER_FROM_GROUP = gql`
  mutation Admin_community_member_remove($memberId: String!) {
    admin_community_member_remove(memberId: $memberId)
  }
`;
